const STEPS = [
  {
    n: "01",
    title: "We review your process",
    body: "A focused working session to walk through how leads come in, how work gets done, and where friction shows up. No giant questionnaires — just honest conversation.",
    meta: "~45 min call · Async prep",
  },
  {
    n: "02",
    title: "We identify the top bottlenecks",
    body: "We map your workflow, score it across lead capture, operations, sales and reporting, then surface the three bottlenecks actually costing you time, leads or revenue.",
    meta: "Bottleneck Scorecard delivered",
  },
  {
    n: "03",
    title: "We deliver practical AI & automation fixes",
    body: "A short, opinionated roadmap: what to fix first, the exact AI or automation approach, recommended tools, and effort-vs-impact ranking. Implement in-house or with us.",
    meta: "Prioritised roadmap + optional build",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="bg-white border-b border-zinc-200" data-testid="how-section">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 reveal">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-orange-600" />
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">
                How It Works
              </span>
            </div>
            <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-zinc-950">
              Three steps from fog to focus.
            </h2>
          </div>
          <p className="text-zinc-600 max-w-md leading-relaxed">
            You don't need a six-week discovery engagement. You need clarity on the three
            things worth fixing this quarter.
          </p>
        </div>

        <ol className="mt-14 grid lg:grid-cols-3 gap-px bg-zinc-200 border border-zinc-200">
          {STEPS.map((s, i) => (
            <li
              key={s.n}
              className="relative bg-white p-8 sm:p-10 flex flex-col reveal"
              data-testid={`step-${i}`}
            >
              <div className="flex items-baseline justify-between">
                <span className="font-display font-bold text-6xl sm:text-7xl text-zinc-950 tracking-tighter leading-none">
                  {s.n}
                </span>
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                  Step {i + 1}/3
                </span>
              </div>
              <h3 className="mt-6 font-display font-semibold text-2xl tracking-tight text-zinc-950">
                {s.title}
              </h3>
              <p className="mt-3 text-zinc-600 leading-relaxed flex-1">{s.body}</p>
              <div className="mt-8 pt-5 border-t border-zinc-200">
                <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-orange-600">
                  {s.meta}
                </span>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
